import {
  ApplicationConfigurationDto,
  ApplicationConfigurationRequestOptions,
  Rest,
  RestService,
} from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable, from, map, tap } from 'rxjs';
import { LocalStorageConsts } from '../AppConsts';
import { LocalConfigurationType } from '../local-db/objects/local-configuration';
import { LocalConfigurationRepository } from '../local-db/repositories/local-configuration-repository';
import { AppUtils } from '../utils/app-utils';

@Injectable({
  providedIn: 'root',
})
export class CustomApplicationConfigurationService {
  private readonly apiName = 'abp';

  constructor(
    private readonly _localConfigurationRepository: LocalConfigurationRepository,
    private readonly _restService: RestService
  ) {}

  get: (
    options: ApplicationConfigurationRequestOptions,
    config?: Partial<Rest.Config>
  ) => Observable<ApplicationConfigurationDto> = (options, config) => {
    const instance = this as CustomApplicationConfigurationService;
    const user = JSON.parse(localStorage.getItem(LocalStorageConsts.CurrentUserKey));

    if (window.navigator.onLine) {
      return instance._restService.request<any, ApplicationConfigurationDto>(
        {
          method: 'GET',
          url: '/api/abp/application-configuration',
          params: {
            includeLocalizationResources: options?.includeLocalizationResources,
          },
        },
        { apiName: instance.apiName, ...config }
      ).pipe(
        tap(response => {
          instance._localConfigurationRepository.set(
            response?.currentUser?.id ?? '',
            LocalConfigurationType.ApplicationConfiguration,
            response
          );
          if (!AppUtils.emptyString(response?.currentUser?.id)) {
            localStorage.setItem(
              LocalStorageConsts.CurrentUserKey,
              JSON.stringify(response.currentUser)
            );
          } else {
            localStorage.removeItem(LocalStorageConsts.CurrentUserKey);
          }
        })
      );
    } else {
      return from(
        instance._localConfigurationRepository.get(
          user?.id ?? '',
          LocalConfigurationType.ApplicationConfiguration
        )
      ).pipe(map(response => response?.data as ApplicationConfigurationDto));
    }
  };
}
